import type { InitData } from 'tradera/state/init-data/types';
import type { MemberState } from 'tradera/state/member/reducer';

export const getInitialState = (
    initData: InitData,
): Omit<
    MemberState,
    | 'hasLoggedIn'
    | 'previousLoginMethod'
    | 'registrationDate'
    | 'isFetchingGeolocation'
    | 'currencyCode'
    | 'blueshiftEventSignature'
    | 'memberIdHash'
    | 'automaticTranslationPreferred'
> => {
    const {
        cleanedMemberAlias,
        facebookId,
        isLoggedIn,
        memberAlias,
        memberDetailedSellerRatingAverage,
        memberCountry,
        memberCountryCodeIso2,
        memberEmail,
        memberEmailMd5,
        memberEmailSha256,
        memberFirstName,
        memberId,
        memberHeroImage,
        memberLastName,
        memberBirthdate,
        memberTown,
        hasTraderaPay,
        isCompany,
        // Age and gender is named `age` and `gender` for the next redux state
        // when implementing this, these values are only used for holid_keyvalues
        // and because I want to keep `age` and `gender` with the same name as in next state
        // I am keeping these values as `age` and `gender` here as well
        memberAge: age,
        memberGender: gender,
        memberIsBuyer,
        memberIsSeller,
        permissions,
        memberState,
        isTrustedMember,
        isImpersonationSession,
    } = initData;
    return {
        cleanedMemberAlias,
        facebookId,
        geolocation: null,
        isLoggedIn,
        memberAlias,
        memberDetailedSellerRatingAverage,
        memberCountry,
        memberCountryCodeIso2,
        memberEmail,
        memberEmailMd5,
        memberEmailSha256,
        memberFirstName,
        memberId,
        memberHeroImage,
        memberLastName,
        memberBirthdate,
        memberTown,
        hasTraderaPay,
        isCompany,
        age,
        gender,
        memberIsBuyer,
        memberIsSeller,
        permissions,
        memberState,
        isTrustedMember,
        isImpersonationSession,
    };
};
